const frontierModules = [
  ["cms-frontier/buyability", "buyability-sub-app/CMSBuyAbility"],
  ["mops/moving-calculator", "mst-ui-components-ccms/MovingCalculator"],
  ["mops/packing-supplies", "mst-ui-components-ccms/PackingSupplies"],
  ["mops/moving-truck", "mst-ui-components-ccms/MovingTruck"],
  ["mops/moving-container", "mst-ui-components-ccms/MovingContainer"],
  ["mops/ads-component", "mst-ui-components-ccms/AdsComponent"],
  ["home-valuation/zestimate-data-table", "zestimate-page-components/ZestimateDataTable"],
  ["home-valuation/zestimate-inline-value", "zestimate-page-components/ZestimateInlineValue"],
  ["constellation/hubspot-embed", "hubspot-cms-ui-components/HubspotUIEmbed"],
  ["zhl/zhl-rate-cards", "zhl-cms-components/ZHLRateCardsMFE"],
  ["zhl/zhl-rate-summary", "zhl-cms-components/RateSummaryMFE"],
  ["mops/hubspot-ui-modal-embed", "hubspot-cms-ui-components/HubspotUIPAFormModal"],
  // Test block for getBlockData support (CMS-5335)
  ["cms-frontier/dummy-block", "cms-frontier/DummyBlock"],
  ["mops/agent-shopping", "agent-shopping-subapp/AgentShoppingActivationLandingPage"],
  ["mops/knotch-demo", "knotch-ace-cms-ui-components/CustomFrame"]
  // Future team registrations:
  // ['mortgage-team/rate-calculator', 'mortgage-sub-app/RateCalculator'],
  // ['rental-team/listing-card', 'rental-sub-app/ListingCard'],
];
export {
  frontierModules
};
